import React , { useEffect , useState } from 'react';
import pageGraphics from "../../../../assets/images/comingsoon.svg";
import Styles from "./styles.module.scss";
import ellowLogo from "../../../../assets/images/ellow-logo.svg";
import Button from "../../../../components/button";
import { EmbeddedgetAPI } from '../../../../api/apis';
import HelloSign from "hellosign-embedded";
import { useLocation , useNavigate } from 'react-router-dom';
import { getSignatureUrlApi , contractDetails } from './services';
import NotificationAlert from "../../../../components/notification";

function ContractSignin() { 

  const location = useLocation()
  let navigate = useNavigate()
  const stateValues: any = location.state 
  const loginId: any =  stateValues.loginId || null
  const candidateJobId: any = stateValues.candidateJobId || null

  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')

  useEffect(() => {

    getSignatureUrl(candidateJobId)
 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  
  const getSignatureUrl = (candidateJobId: any) => {
    
    getSignatureUrlApi(candidateJobId).then((response: any) => {
      if(response && response.signature_id){
        EmbeddedgetAPI(`https://api.hellosign.com/v3/embedded/sign_url/${response.signature_id}`).then((resp: any) => {   
          const client = new HelloSign({
            clientId: "a86c6f59ea03bceba480b19cd2f7b370"
          })
          client.open(resp.embedded.sign_url, {
            testMode: true
          })
        })
        .catch((err: any) => {
          displayNotification('Contract agreement already signed!')
        })
      }
    })
  }

  const getContractDetails = () => {
    let body = {
        candidateJobId: candidateJobId
    }
    contractDetails(body).then((resp: any) => {
      if(resp && resp.status === 1){
        if(resp.data[0].contractSigned === true){
          navigate(`/dashboard`, { state: { loginId: loginId }})
        }
      }
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const simulation = () => {
    getContractDetails()
    setTimeout(simulation, 5000)
  }

  const displayNotification = (message: any) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
    }, 4000);
  }

  const onClose = () => {
    setNotification(false)
  }
 
  return (

    <section className={Styles.verifiWrapper}>
      <div className={Styles.header}>
        <img src={ellowLogo} alt="ellow.io" />
      </div>
      <div className={Styles.errorMessage}> 
        <img src={pageGraphics} alt='pageGraphics'/>
        <Button type="submit" onClick={()  => {getSignatureUrl(candidateJobId)}} variant="primary">Initiate Contract</Button><br></br>
        <p> In case of any queries , Please reach out to us at</p>
        <a href="mailti:support@ellow.io" className={Styles.link}>team@ellow.io</a>
      </div>
      {notification && <NotificationAlert onClose={onClose} closable={true} > {message} </NotificationAlert> }
    </section>
  )
}

export default ContractSignin